import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/utils/lib";

const nameWidths = ["w-[140px]", "w-[112px]", "w-[156px]", "w-[128px]"];
const metaWidths = ["w-[132px]", "w-[118px]", "w-[144px]", "w-[126px]"];
const priceWidths = ["w-[84px]", "w-[96px]", "w-[76px]", "w-[90px]"];
const bodyWidths = ["w-[92%]", "w-[84%]", "w-[88%]", "w-[80%]"];
const bodySecondaryWidths = ["w-[78%]", "w-[68%]", "w-[74%]", "w-[62%]"];

export const FeedPostSkeletonList = ({
  count = 10,
  withLeadingBorder = false,
}: {
  count?: number;
  withLeadingBorder?: boolean;
}) => {
  return Array.from({ length: count }, (_, index) => (
    <div
      key={index}
      className={cn("unforce-radius relative w-full border-border-light", {
        "border-t": withLeadingBorder || index > 0,
      })}
    >
      <div
        className="
          p-4
          md:hidden
        "
      >
        <div className="flex items-start gap-3">
          <div className="min-w-0 flex-1 space-y-4">
            <div className="flex items-start justify-between gap-3">
              <div className="flex min-w-0 items-start gap-3">
                <Skeleton className="size-[54px] shrink-0 rounded-full" />
                <div className="min-w-0 space-y-2">
                  <Skeleton className={cn("h-5", nameWidths[index % 4])} />
                  <Skeleton className={cn("h-3", metaWidths[index % 4])} />
                  <Skeleton className={cn("h-3", priceWidths[index % 4])} />
                </div>
              </div>

              <div className="flex items-start gap-2">
                <Skeleton className="mt-1 size-4 rounded-full" />
                <div className="flex min-h-[76px] flex-col items-center gap-2">
                  <Skeleton className="size-5 rounded-full" />
                  <Skeleton className="h-4 w-9 rounded-md" />
                  <Skeleton className="size-5 rounded-full" />
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <Skeleton className={cn("h-5", bodyWidths[index % 4])} />
              <Skeleton className={cn("h-5", bodySecondaryWidths[index % 4])} />
            </div>

            <Skeleton className="h-8 w-10 rounded-md" />

            <div className="flex items-center justify-between gap-4 pt-1">
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2">
                  <Skeleton className="size-4 rounded-full" />
                  <Skeleton className="size-3" />
                </div>
                <div className="flex items-center gap-2">
                  <Skeleton className="size-4 rounded-full" />
                  <Skeleton className="size-3" />
                </div>
                <Skeleton className="size-4 rounded-full" />
                <div className="flex items-center gap-2">
                  <Skeleton className="size-4 rounded-full" />
                  <Skeleton className="size-3" />
                </div>
                <Skeleton className="size-4 rounded-full" />
              </div>

              <div className="flex items-center gap-2">
                <Skeleton className="size-4 rounded-full" />
                <Skeleton className="h-3 w-6" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="
          hidden items-stretch gap-4 p-4
          md:flex md:p-6
          xl:p-8
        "
      >
        <div
          className="
            items-center justify-start gap-3
            md:flex md:flex-col
          "
        >
          <Skeleton className="size-14 rounded-full" />
          <div className="flex min-h-[64px] flex-col items-center gap-2">
            <Skeleton className="size-5 rounded-full" />
            <Skeleton className="h-4 w-12 rounded-md" />
            <Skeleton className="size-5 rounded-full" />
          </div>
        </div>

        <div className="flex w-full flex-col gap-4">
          <div className="flex items-start justify-between gap-3">
            <div className="flex min-w-0 items-start gap-3">
              <div className="min-w-0 space-y-2">
                <Skeleton className={cn("h-5", nameWidths[index % 4])} />
                <div className="flex items-center gap-2">
                  <Skeleton className={cn("h-3", metaWidths[index % 4])} />
                  <Skeleton className="h-3 w-[52px]" />
                </div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div
                className="
                  hidden items-center gap-2
                  sm:flex
                "
              >
                <Skeleton className="size-4 rounded-sm" />
                <Skeleton className="h-4 w-14" />
                <Skeleton className="h-4 w-16" />
              </div>
              <Skeleton className="mt-1 size-4 rounded-full" />
            </div>
          </div>

          <div className="space-y-2">
            <Skeleton className={cn("h-5", bodyWidths[index % 4])} />
            <Skeleton className={cn("h-5", bodySecondaryWidths[index % 4])} />
          </div>

          <Skeleton className="h-8 w-10 rounded-md" />

          <div className="flex items-center justify-between gap-4 pt-1">
            <div
              className="
                flex items-center gap-4
                sm:gap-6
              "
            >
              <Skeleton className="size-4 rounded-full" />
              <div className="flex items-center gap-2">
                <Skeleton className="size-4 rounded-full" />
                <Skeleton className="size-3" />
              </div>
              <Skeleton className="size-4 rounded-full" />
              <div className="flex items-center gap-2">
                <Skeleton className="size-4 rounded-full" />
                <Skeleton className="size-3" />
              </div>
              <Skeleton className="size-4 rounded-full" />
            </div>

            <div className="flex items-center gap-2">
              <Skeleton className="size-4 rounded-full" />
              <Skeleton className="h-3 w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  ));
};
